import React from "react";
import RoleForm from "./RoleForm";

const AddRoleModal = (props) => {
  return <RoleForm {...props} title="Add New Role" type="add" />;
};

export default AddRoleModal;
